var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C16.2 15.322 17.526 13.995 21 13C17.526 12.005 16.2 10.678 15 7C13.8 10.678 12.474 12.005 9 13C12.474 13.995 13.8 15.322 15 19ZM7 10C7.6 8.16 8.263 7.497 10 7C8.263 6.503 7.6 5.84 7 4C6.4 5.84 5.737 6.503 4 7C5.737 7.497 6.4 8.16 7 10ZM8.5 20C8.8 19.08 9.131 18.749 10 18.5C9.131 18.251 8.8 17.92 8.5 17C8.2 17.92 7.869 18.251 7 18.5C7.869 18.749 8.2 19.08 8.5 20Z",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCollapseIcon);
export default __webpack_public_path__ + "static/media/AICollapseIcon.72cfaac1a9d4bb10f6d64278e6d8dabc.svg";
export { ForwardRef as ReactComponent };